var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
export default class Traits {
  constructor(namespace = "") {
    this.namespace = namespace;
    this.traitsKey = this.namespace ? `${this.namespace}_tint_identify_traits` : "tint_identify_traits";
  }
  store(params) {
    if (!params || typeof params !== "object") {
      console.warn("Invalid parameters provided to store.");
      return;
    }
    let userTraits = this.get();
    if (userTraits === null) {
      userTraits = {};
    }
    let updatedTraits = __spreadValues(__spreadValues({}, userTraits), params);
    try {
      localStorage.setItem(this.traitsKey, JSON.stringify(updatedTraits));
    } catch (e) {
      if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") {
        console.error("Quota exceeded. Could not store updated traits.");
        console.error("current traits: ", JSON.stringify(updatedTraits));
      } else {
        console.error("Error setting item in localStorage", e);
      }
    }
  }
  get() {
    let userTraits = localStorage.getItem(this.traitsKey);
    return userTraits ? JSON.parse(userTraits) : {};
  }
}
